import { FacilityExpenseCaps } from 'src/app/shared/models/facility-expense-caps.model';
import { MarginExpenseType } from '../../models/margin-expense-type.model';
import { MarginExpense } from '../../models/margin-expense.model';

export interface MarginExpensesSlice {
    marginExpenses: MarginExpense[];
    marginExpenseTypes: MarginExpenseType[];
    expenseCaps: FacilityExpenseCaps[];
}

export const initialMarginExpensesSlice: MarginExpensesSlice = {
    marginExpenses: [],
    marginExpenseTypes: [],
    expenseCaps: []
};
